import { CURRENT_ERROR } from "../constants";

export function currentError(error) {
  return {
    type: CURRENT_ERROR,
    error
  };
}



// WEBPACK FOOTER //
// ./src/store/actions/ErrorActions.js